import { Types } from 'mongoose';
import { z } from 'zod';

export const TemplateResponseSchema = z.object({
  _id: z.instanceof(Types.ObjectId),
  companyId: z.string(),
  name: z.string(),
  content: z.string(),
  url: z.string(),
  createdBy: z.string(),
});

export const TemplateResponseFormSchema = TemplateResponseSchema.pick({
  name: true,
  content: true,
  url: true,
});
